import React from 'react'
import { useSelector } from 'react-redux'
import { get } from 'lodash'
import L from '../L'
import { WEBSITE_CONFIG_COLLECTION, WEBSITE_CONFIG_ID } from '../../Config'
import StyledFooter from './Footer-styles'

const Footer = () => {
  const firestore = useSelector(({ firestore }) => firestore) || {}
  const config = get(firestore, `data.${WEBSITE_CONFIG_COLLECTION}.${WEBSITE_CONFIG_ID}`)

  if (!config) return null

  return (
    <StyledFooter>
      <L display="flex" jc="flex-start" ai="center" container>
        {config.footerLogo.signedUrl && <img src={require('../../Images/LogoIdeaCloud.svg')} alt="IdeaCloud logo" />}
      </L>
    </StyledFooter>
  )
}

export default Footer
